"use client"

import { MessageCircleIcon, PhoneIcon } from "lucide-react"

import { whatsappHref } from "@/features/members/components/members-views"
import { useTranslations } from "@/i18n"

const BUTTON_CLASS =
  "inline-flex size-7 shrink-0 items-center justify-center rounded-full focus-visible:ring-2 focus-visible:ring-ring focus-visible:outline-none"

/**
 * Compact call and WhatsApp buttons for a person row. WhatsApp only for an international number (`+...`),
 * exactly the rule the member preview uses; no phone, no buttons.
 */
export function PersonContactButtons({
  name,
  phone,
  showCall = true,
}: {
  name: string
  phone: string | null
  showCall?: boolean
}) {
  const t = useTranslations("dashboard.home.contact")
  if (!phone) return null
  const whatsapp = whatsappHref(phone)
  return (
    <span className='flex shrink-0 items-center gap-1.5'>
      {showCall ? (
        <a href={`tel:${phone}`} aria-label={t("call", { name })} className={`${BUTTON_CLASS} bg-muted text-foreground hover:bg-muted/70`}>
          <PhoneIcon aria-hidden className='size-3.5' />
        </a>
      ) : null}
      {whatsapp ? (
        <a
          href={whatsapp}
          target='_blank'
          rel='noreferrer'
          aria-label={t("whatsapp", { name })}
          className={`${BUTTON_CLASS} bg-emerald-50 text-emerald-700 hover:bg-emerald-100 dark:bg-emerald-950/50 dark:text-emerald-400`}
        >
          <MessageCircleIcon aria-hidden className='size-3.5' />
        </a>
      ) : null}
    </span>
  )
}
